export const content = {
    orders: {
        title: 'Order Management',
        orderNumber: 'Order No.',
        customer: 'Customer',
        product: 'Product',
        quantity: 'Quantity',
        price: 'Price',
        shippingCost: 'Shipping Cost',
        paymentMethod: 'Payment Method',
        shippingMethod: 'Shipping Method',
        orderDate: 'Order Date',
        pending: 'Pending',
        processing: 'Processing',
        shipped: 'Shipped',
        delivered: 'Delivered',
        canceled: 'Canceled',
        pendingDeletion: 'Pending Deletion',
        filterByStatus: 'Filter by Status',
        filterByBrand: 'Filter by Brand',
        filterByDate: 'Filter by Date',
        whatsappConfirm: 'Confirm via WhatsApp',
        deleteOrder: 'Delete Order',
        confirmDelete: 'Are you sure you want to delete this order?',
    },
    customers: {
        title: 'Customer Management',
        addCustomer: 'Add Customer',
        editCustomer: 'Edit Customer',
        customerName: 'Customer Name',
        totalSpent: 'Total Spent',
        orderCount: 'Order Count',
        lastOrder: 'Last Order',
        customerScore: 'Customer Score',
        viewOrders: 'View Orders',
    },
    forms: {
        title: 'Forms',
        createForm: 'Create Form',
        editForm: 'Edit Form',
        formName: 'Form Name',
        productName: 'Product Name',
        productPrice: 'Product Price',
        productImage: 'Product Image',
        productDescription: 'Product Description',
        viewForm: 'View Form',
        copyLink: 'Copy Link',
        linkCopied: 'Link copied!',
        deleteForm: 'Delete Form',
        duplicateForm: 'Duplicate Form',
    },
    abandonedCarts: {
        title: 'Abandoned Carts',
        customerInfo: 'Customer Info',
        cartItems: 'Cart Items',
        abandonedAt: 'Abandoned At',
        followUp: 'Follow Up',
        contacted: 'Contacted',
        markContacted: 'Mark as Contacted',
    },
};
